import { ChangeEvent, ClipboardEvent, FocusEvent, useState } from 'react';
import CustomPasswordMessage from '../customPasswordMessage/CustomPasswordMessage';
import EyeIcon from '../icons/eyeIcon/EyeIcon';
import styles from './inputForm.module.scss';

interface IInputFormProps {
  label: string;
  name: string;
  type?: 'text' | 'password';
  placeholder?: string;
  value: string;
  readOnly?: boolean;
  error?: string | boolean;
  onChange?: (name: string, event: ChangeEvent<HTMLInputElement>) => void;
  onBlur?: (name: string, event: FocusEvent<HTMLInputElement>) => void;
  onResetError?: () => void;
  autoComplete?: string;
}

function InputForm({
  value,
  label,
  onChange,
  type = 'text',
  placeholder,
  name,
  readOnly,
  error,
  onResetError,
  autoComplete,
}: IInputFormProps) {
  // state used to hide or not field text
  const [eyeVisible, setEyeVisible] = useState<boolean>(false);

  // show or hide field text
  const handleEyeClick = () => setEyeVisible(!eyeVisible);

  // forbid copy and cut for this input
  const handleCopyCut = (e: ClipboardEvent<HTMLDivElement>) => {
    e.preventDefault();
  };

  return (
    <fieldset className={styles.fieldset}>
      <label htmlFor={name}>{`${label} :`} </label>
      <div className={styles.inputBorderContainer}>
        <div
          className={[styles.inputContainer, error ? styles.error : ''].join(' ')}
        >
          <input
            type={eyeVisible ? 'text' : type}
            name={name}
            placeholder={placeholder}
            readOnly={readOnly}
            value={value}
            onChange={(e) => onChange?.(name, e)}
            onCut={handleCopyCut}
            onCopy={handleCopyCut}
            autoComplete={autoComplete}
            list="hiddenPasswordSuggestions"
          />
          <datalist id="hiddenPasswordSuggestions">
            <option value=" " />
          </datalist>
          {type === 'password' ? (
            <EyeIcon
              strikeout={eyeVisible}
              bgColor={error ? '#FFECFC' : '#FFF'}
              onClick={handleEyeClick}
            />
          ) : null}
        </div>
        {error ? (
          typeof error === 'string' ? (
            <p>{error}</p>
          ) : (
            <CustomPasswordMessage
              value={value}
              onResetError={() => onResetError?.()}
            />
          )
        ) : null}
      </div>
    </fieldset>
  );
}

export default InputForm;
